"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyguardAbilityHandler = exports.BodyguardActorAbilityFactory = exports.BodyguardAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Block_1 = require("../../core/effects/core/Block");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BodyguardAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bodyguard;
        this.__typeName = "Bodyguard";
    }
}
exports.BodyguardAbilityArgs = BodyguardAbilityArgs;
let BodyguardActorAbilityFactory = class BodyguardActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bodyguard", "OneAllies", 1);
    }
};
BodyguardActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bodyguard")
], BodyguardActorAbilityFactory);
exports.BodyguardActorAbilityFactory = BodyguardActorAbilityFactory;
let BodyguardAbilityHandler = class BodyguardAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId,
                    effect: new Block_1.BlockEffectArgs(),
                    duration: Duration_1.Duration.Turns(4),
                    onApplied: sequence => sequence.push(new core_1.AnimateCharacterVfxStepArgs("healed", new LocationSelector_1.ActorVfxLocationSelector(targetId, "head")))
                });
            }
        });
    }
};
BodyguardAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bodyguard)
], BodyguardAbilityHandler);
exports.BodyguardAbilityHandler = BodyguardAbilityHandler;
